import { Tooltip, Typography } from 'antd';

const { Text } = Typography;
export const EllipsisAndTooltip: React.FC<{ children: any }> = ({ children }) => {
  return (
    <Tooltip title={children}>
      <Text style={{ maxWidth: '100%' }} ellipsis>
        {children}
      </Text>
    </Tooltip>
  );
};
